import React from "react";

const ImageCostModal = ({
  isOpen,
  onClose,
  imageCostSettings,
  setImageCostSettings,
  handleUpdateImageCost,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h3 className="text-xl font-bold mb-4">Update Image/Page Costs</h3>
        <div className="mb-6">
          <h4 className="font-medium text-gray-700 mb-3">Black & White</h4>
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-gray-700 mb-2">A4 Cost (₹)</label>
              <input
                type="number"
                value={imageCostSettings?.blackAndWhite?.A4}
                onChange={(e) =>
                  setImageCostSettings((prev) => ({
                    ...prev,
                    blackAndWhite: {
                      ...prev.blackAndWhite,
                      A4: parseFloat(e.target.value) || 0,
                    },
                  }))
                }
                className="w-full p-2 border border-gray-300 rounded-md"
                step="0.5"
                min="0"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-2">A3 Cost (₹)</label>
              <input
                type="number"
                value={imageCostSettings?.blackAndWhite?.A3}
                onChange={(e) =>
                  setImageCostSettings((prev) => ({
                    ...prev,
                    blackAndWhite: {
                      ...prev.blackAndWhite,
                      A3: parseFloat(e.target.value) || 0,
                    },
                  }))
                }
                className="w-full p-2 border border-gray-300 rounded-md"
                step="0.5"
                min="0"
              />
            </div>
          </div>
        </div>
        <div className="mb-6">
          <h4 className="font-medium text-gray-700 mb-3">Color</h4>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 mb-2">A4 Cost (₹)</label>
              <input
                type="number"
                value={imageCostSettings?.color?.A4}
                onChange={(e) =>
                  setImageCostSettings((prev) => ({
                    ...prev,
                    color: {
                      ...prev.color,
                      A4: parseFloat(e.target.value) || 0,
                    },
                  }))
                }
                className="w-full p-2 border border-gray-300 rounded-md"
                step="0.5"
                min="0"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-2">A3 Cost (₹)</label>
              <input
                type="number"
                value={imageCostSettings?.color?.A3}
                onChange={(e) =>
                  setImageCostSettings((prev) => ({
                    ...prev,
                    color: {
                      ...prev.color,
                      A3: parseFloat(e.target.value) || 0,
                    },
                  }))
                }
                className="w-full p-2 border border-gray-300 rounded-md"
                step="0.5"
                min="0"
              />
            </div>
          </div>
        </div>
        <div className="flex justify-end space-x-2">
          <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400">
            Cancel
          </button>
          <button
            onClick={() => {
              handleUpdateImageCost();
              onClose();
            }}
            className="px-4 py-2 bg-purple-500 text-white rounded-md hover:bg-purple-600"
          >
            Update Costs
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageCostModal;
